import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function CalloutElement({ children, className, element, ...props }: PlateElementProps) {
	const icon = (element.icon as string) || "\u{1F4A1}";

	return (
		<PlateElement
			{...props}
			element={element}
			className={cn("my-2 flex items-start gap-2 rounded-lg border bg-muted/50 p-4", className)}
		>
			<span className="select-none text-lg" contentEditable={false}>
				{icon}
			</span>
			<div className="min-w-0 flex-1">{children}</div>
		</PlateElement>
	);
}
